import Vue from 'vue'
import Vuex from 'vuex'

import userModule from "./modules/user";
import notificationModule from "./modules/notification"
import transactionModule from "./modules/transaction";
import searchModule from "./modules/search";
import referentielModule from "./modules/referentiel";

import {USER_NS} from "@/store/modules/user/constants";
import {TRANSACTION_NS} from "@/store/modules/transaction/constants";
import {SEARCH_NS} from "@/store/modules/search/constants";
import {NOTIFICATION_NS} from "@/store/modules/notification/constants";
import {REFERENTIEL_NS} from "@/store/modules/referentiel";


Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        [USER_NS]: userModule,
        [REFERENTIEL_NS]: referentielModule,
        [NOTIFICATION_NS]: notificationModule,
        [TRANSACTION_NS]: transactionModule,
        [SEARCH_NS]: searchModule
    }
})